"use client";
import React, { useEffect } from "react";

import {
  ChartAreaIcon,
  IndianRupeeIcon,
  Loader2Icon,
  Table2Icon,
  TableIcon,
} from "lucide-react";

import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components/ui/table";

import { PNLChart } from "./pnl-chart";
import { DonutChart } from "./donut-chart";
import { CummPNLChart } from "./cumm-pnl-chart";
import { SourceWisePNLChart } from "./source-wise-pnl-chart";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../../components/ui/tabs";
import { Button } from "../../components/ui/button";
import { DailyPNLChart } from "./daily-pnl-chart";
import { useState } from "react";
import MetricsTableOne from "./metrics-table-1";
import MonthlyPnlTable from "./monthly-pnl-table";
import HeatmpaCalendar from "./heatmap-cal";
import formatToIndianCurrency from "../../utils/formatCurrency";
import LoadingSpinner from "../../components/loading-spinner";
import { StrategyCumulativePNLChart } from "./strategy-weekly-pnl-chart";
import { StrategyMetricsTable } from "./strategy-metrics-table";
import { SourceWisePnlTable } from "./source_wise_table_pnl";
import server from "../../utils/serverConfig";
import apiClient from "../../utils/apiClient";

export default function MetricsPage({dkpMetricsData, assetMetricsData}) {

  const dpk_trade_metrics = dkpMetricsData && dkpMetricsData;
  const [metricsData, setMetricsData] = useState({});
  const [dailyPnlData, setDailyPnlData] = useState([]);
  const [cummPnlData, setCummPnlData] = useState([]);
  const [monthlyPnlData, setmonthlyPnlData] = useState([]);
  const [weekdaysPnl, setWeekdaysPnl] = useState({});
  const [strategyWiseTradeMetrics, setStrategyWiseTradeMetrics] = useState([]);
  const [yearWiseStrategyWiseMonthlyPnl, setYearWiseStrategyWiseMonthlyPnl] =
    useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [viewFormat, setViewFormat] = useState("chart-view");
  const [assetDailyPnl, setAssetDailyPnl] = useState({});
  const [assetCummPnl, setAssetCummPnl] = useState({});
  const [dailyPnlMerged, setDailyPnlMerged] = useState([]);
  const [weekDailyPnlMerged, setWeekDailyPnlMerged] = useState([]);
  const [cummPnlMerged, setCummPnlMerged] = useState([]);
  const [weekCummPnlMerged, setWeekCummPnlMerged] = useState([]);
  const [cummPnlView, setCummPnlView] = useState("weekly");
  const [dailyPnlView, setDailyPnlView] = useState("weekly");
  const [strategyCumulativePnl, setStrategyCumulativePnl] = useState([]);
  const [strategyMetricsData, setStrategyMetricsData] = useState([]);
  const [sourceDailyPnl, setSourceDailyPnl] = useState({});
  const [sourceWeeklyPnl, setSourceWeeklyPnl] = useState({});
  const [sourceWisePnlTableData, setSourceWisePnlTableData] = useState([]);

  useEffect(() => {
    setIsLoading(true);
  
    // Check if data is available before destructuring
    if (dpk_trade_metrics) {
      const overall_metrics = dpk_trade_metrics.overall_metrics || {};
      const daily_pnl = dpk_trade_metrics.day_wise_pnl || [];
      const cumm_pnl = dpk_trade_metrics.cumulative_pnl || [];
      const monthly_pnl = dpk_trade_metrics.month_wise_pnl_data || [];
      const weekdays_pnl = dpk_trade_metrics.weekdays_pnl || {};
      const strategy_wise_trade_metrics = dpk_trade_metrics.strategy_wise_trade_metrics || [];
      const year_wise_strategy_wise_monthly_pnl = dpk_trade_metrics.year_wise_strategy_wise_monthly_pnl || [];
  
      setMetricsData(overall_metrics);
      setDailyPnlData(daily_pnl);
      setCummPnlData(cumm_pnl);
      setmonthlyPnlData(monthly_pnl);
      setWeekdaysPnl(weekdays_pnl);
      setStrategyWiseTradeMetrics(strategy_wise_trade_metrics);
      setYearWiseStrategyWiseMonthlyPnl(year_wise_strategy_wise_monthly_pnl);
    }
  
    // Use correct keys from backend: day_wise_pnl and cumulative_pnl
    if (assetMetricsData && assetMetricsData.day_wise_pnl && assetMetricsData.cumulative_pnl) {
      setAssetDailyPnl(assetMetricsData.day_wise_pnl);
      setAssetCummPnl(assetMetricsData.cumulative_pnl);
      setDailyPnlMerged(assetMetricsData.daily_pnl_merged || []);
      setCummPnlMerged(assetMetricsData.cumulative_pnl_merged || []);
      setWeekCummPnlMerged(assetMetricsData.week_cumulative_pnl_merged || []);
      setWeekDailyPnlMerged(assetMetricsData.week_daily_pnl_merged || []);
    }

    const fetchSourceWisePnlData = async () => {
      try {
        const sourceWisePnlRes = await apiClient.get(
          `${server.godseye.baseUrl}source-wise-table-pnl`
        );
        const sourceWisePnlData = sourceWisePnlRes.data;
        setSourceWisePnlTableData(sourceWisePnlData);
      } catch (error) {
        console.error("Failed to fetch source wise pnl table data:", error);
      }
    };

    fetchSourceWisePnlData();
  
    // Introduce a 5-second delay before setting isLoading to false
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 5000); // 5000ms = 5 seconds
  
    // Clean up the timer when the component is unmounted or dependencies change
    return () => clearTimeout(timer);
  }, [dpk_trade_metrics, assetMetricsData]);
  

  console.log("got metrics---->", metricsData);
  console.log("daily data metrics---->", dailyPnlData);

  const cardData = [
    {
      title: "Total PNL",
      value: formatToIndianCurrency(metricsData?.total_pnl) || "0",
      icon: <IndianRupeeIcon className="h-5 w-5 text-white" />,
      type: "currency",
    },
    // {
    //   title: "Cumulative PNL",
    //   value: formatToIndianCurrency(metricsData?.total_pnl + 1000000) || "0",
    //   icon: <IndianRupeeIcon className="h-5 w-5 text-white" />,
    //   type: "currency",
    // },
    {
      title: "Avg. Win",
      value: formatToIndianCurrency(metricsData?.avg_profit_win_trade) || "0",
      icon: <IndianRupeeIcon className="h-5 w-5 text-white" />,
      type: "currency",
    },
    {
      title: "Avg. Loss",
      value: formatToIndianCurrency(metricsData?.avg_loss_loss_trade) || "0",
      icon: <IndianRupeeIcon className="h-5 w-5 text-white" />,
      type: "currency",
    },
    {
      title: "Accuracy Day (in %)",
      value: metricsData?.accuracy_days_in_percent || "0%",
      icon: null,
      type: "number",
    },
    {
      title: "Accuracy Trades (in %)",
      value: metricsData?.accuracy_trades_in_percent || "0%",
      icon: null,
      type: "number",
    },
    {
      title: "Total Win Days",
      value: metricsData?.total_winning_days || "0",
      icon: null,
      type: "number",
    },
    {
      title: "Total Loss Days",
      value: metricsData?.total_loss_days || "0",
      icon: null,
      type: "number",
    },
    {
      title: "Win Ratio",
      value: metricsData?.win_ratio || "0",
      icon: null,
      type: "number",
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        // Fetch strategy cumulative PNL data
        const strategyCumulativeResponse = await apiClient.get(`${server.godseye.baseUrl}strategy-daily-cumulative-pnl`);
        const strategyCumulativeData = strategyCumulativeResponse.data;
        setStrategyCumulativePnl(strategyCumulativeData);

        // Fetch strategy metrics table data
        const strategyMetricsResponse = await apiClient.get(`${server.godseye.baseUrl}strategy-wise-table`);
        const strategyMetricsData = strategyMetricsResponse.data;
        setStrategyMetricsData(strategyMetricsData);

        // Fetch source-wise daily PNL data
        const sourceDailyResponse = await apiClient.get(`${server.godseye.baseUrl}positions-daily-pnl-by-source-tag`);
        const sourceDailyData = sourceDailyResponse.data;
        console.log("Source Daily PNL Data:", sourceDailyData);
        setSourceDailyPnl(sourceDailyData);

        // Fetch source-wise weekly PNL data
        const sourceWeeklyResponse = await apiClient.get(`${server.godseye.baseUrl}positions-weekly-pnl-by-source-tag`);
        const sourceWeeklyData = sourceWeeklyResponse.data;
        console.log("Source Weekly PNL Data:", sourceWeeklyData);
        setSourceWeeklyPnl(sourceWeeklyData);

      } catch (error) {
        console.error("Error fetching data:", error);
        setStrategyCumulativePnl({});
        setStrategyMetricsData([]);
        setSourceDailyPnl({});
        setSourceWeeklyPnl({});
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="min-h-screen w-full">
      <main className="flex flex-1 overflow-hidden flex-col w-full h-full p-2 transition-all duration-300 ease-in-out ">
        <div>
          {isLoading && !metricsData ? (
            <div className="flex items-center justify-center min-h-screen">
              <LoadingSpinner />
            </div>
          ) : (
            <div className="flex justify-between w-full h-full py-2 px-2">
              <Tabs defaultValue="dpk-account" className="w-full">
                <div className="flex  justify-between    ">
                  <TabsList className="grid  grid-cols-2 w-[400px]">
                    <TabsTrigger value="dpk-account">DPK Account</TabsTrigger>
                    <TabsTrigger value="other-account">
                      Other Account
                    </TabsTrigger>
                  </TabsList>
                  <div className="flex items-center justify-end w-[400px]">
                    <Button
                      onClick={() => setViewFormat("chart-view")}
                      variant="ghost"
                      className={`h-8 w-8 cursor-pointer ${
                        viewFormat === "chart-view"
                          ? "bg-muted text-white/80"
                          : ""
                      }`}
                      size="icon"
                    >
                      <ChartAreaIcon className="w-5 h-5 " />
                    </Button>
                    <Button
                      onClick={() => setViewFormat("table-view")}
                      variant="ghost"
                      className={`h-8 w-8 cursor-pointer ${
                        viewFormat === "table-view"
                          ? "bg-muted text-white/80"
                          : ""
                      }`}
                      size="icon"
                    >
                      <TableIcon className="w-5 h-5" />
                    </Button>
                  </div>
                </div>

                <TabsContent
                  value="dpk-account"
                  className=" w-full rounded-md "
                >
                  {viewFormat === "chart-view" && (
                    <div className="w-full">
                      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-x-4">
                        <div className="grid grid-cols-3 gap-x-3 gap-y-2.5 col-span-4">
                          {cardData.map((card, index) => (
                            <Card key={index}>
                              <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                                <CardTitle className="text-sm font-medium">
                                  {card.title}
                                </CardTitle>
                                {card.icon && (
                                  <IndianRupeeIcon className="h-4 w-4 text-muted-foreground" />
                                )}
                              </CardHeader>
                              <CardContent className="px-6 py-2">
                                <div
                                  className={`flex items-center text-xl font-bold ${
                                    card.type === "currency"
                                      ? parseFloat(
                                          card.value.replace(/[^0-9.-]+/g, "")
                                        ) > 0
                                        ? "text-teal-400"
                                        : parseFloat(
                                            card.value.replace(/[^0-9.-]+/g, "")
                                          ) < 0
                                        ? "text-rose-400"
                                        : ""
                                      : "text-blue-400"
                                  }`}
                                >
                                  {card.value}
                                </div>
                              </CardContent>
                            </Card>
                          ))}
                        </div>

                        <div className="col-span-2">
                          <DonutChart
                            totalPnl={metricsData?.total_pnl}
                            niftyPnl={metricsData?.nifty}
                            bankniftyPnl={metricsData?.banknifty}
                            stocksPnl={metricsData?.stock}
                          />
                        </div>
                      </div>

                      <div className="grid grid-cols-12 gap-x-4 mt-6 ">
                        <div className="col-span-12 ">
                          <DailyPNLChart
                            dailyPnlMerged={dailyPnlView === "daily" ? dailyPnlMerged : weekDailyPnlMerged}
                            assetDailyPnl={assetDailyPnl}
                            isWeekly={dailyPnlView === "weekly"}
                            dailyPnlView={dailyPnlView}
                            setDailyPnlView={setDailyPnlView}
                          />
                        </div>
                      </div>
                      {/* 2. Monthly PNL Chart */}
                      <div className="grid grid-cols-12 gap-x-4 mt-6 ">
                        <div className="col-span-12 ">
                          <PNLChart monthlyPnlData={monthlyPnlData} />
                        </div>
                      </div>
                      {/* 3. Cumulative PNL Chart */}
                      <div className="grid grid-cols-12 gap-x-4 mt-6 ">
                        <div className="col-span-12 ">
                          <CummPNLChart
                            cummPnlMerged={cummPnlView === "daily" ? cummPnlMerged : weekCummPnlMerged}
                            assetCummPnl={assetCummPnl}
                            isWeekly={cummPnlView === "weekly"}
                            cummPnlView={cummPnlView}
                            setCummPnlView={setCummPnlView}
                          />
                        </div>
                      </div>
                      {/* 4. Strategy Cumulative PNL Chart */}
                      <div className="grid grid-cols-12 gap-x-4 mt-6">
                        <div className="col-span-12">
                          <StrategyCumulativePNLChart data={strategyCumulativePnl} />
                        </div>
                      </div>

                      {/* Strategy Metrics Table */}
                      <div className="grid grid-cols-12 gap-x-4">
                        <div className="col-span-12">
                          <StrategyMetricsTable data={strategyMetricsData} />
                        </div>
                      </div>

                      {/* Source-wise PNL Chart */}
                      <div className="grid grid-cols-12 gap-x-4 mt-6">
                        <div className="col-span-12">
                        <SourceWisePNLChart 
                          data={sourceDailyPnl} 
                          weeklyData={sourceWeeklyPnl} 
                        />
                        </div>
                      </div>

                      <div className="grid grid-cols-12 gap-x-4 mt-6 ">
                        <div className="col-span-12 ">
                          <SourceWisePnlTable data={sourceWisePnlTableData} />
                        </div>
                      </div>
                    </div>
                  )}

                  {viewFormat === "table-view" && (
                    <div className="w-full">
                      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-x-4">
                        <div className="grid grid-cols-3 gap-x-3 gap-y-2 col-span-3">
                          {cardData.map((card, index) => (
                            <Card key={index}>
                              <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                                <CardTitle className="text-sm font-medium">
                                  {card.title}
                                </CardTitle>
                                {card.icon && (
                                  <IndianRupeeIcon className="h-4 w-4 text-muted-foreground" />
                                )}
                              </CardHeader>
                              <CardContent className="px-6 py-2">
                                <div
                                  className={`flex items-center text-xl font-bold ${
                                    card.type === "currency"
                                      ? parseFloat(
                                          card.value.replace(/[^0-9.-]+/g, "")
                                        ) > 0
                                        ? "text-teal-400"
                                        : parseFloat(
                                            card.value.replace(/[^0-9.-]+/g, "")
                                          ) < 0
                                        ? "text-rose-400"
                                        : ""
                                      : "text-blue-400"
                                  }`}
                                >
                                  {card.value}
                                </div>
                              </CardContent>
                            </Card>
                          ))}
                        </div>

                        <div className="col-span-2">
                          <Card className="p-0">
                            <CardContent className="p-0">
                              <Table>
                                <TableHeader className="bg-muted">
                                  <TableRow>
                                    <TableHead>Returns by Day</TableHead>
                                    <TableHead className="text-right">
                                      PNL
                                    </TableHead>
                                  </TableRow>
                                </TableHeader>
                                <TableBody>
                                  {weekdaysPnl.map((item, index) => (
                                    <TableRow key={index}>
                                      <TableCell className="text-left px-4">
                                        {item.day}
                                      </TableCell>
                                      <TableCell
                                        className={`font-semibold text-right py-4 ${
                                          item.pnl > 0
                                            ? "text-teal-400"
                                            : item.pnl < 0
                                            ? "text-rose-400"
                                            : ""
                                        }`}
                                      >
                                        {formatToIndianCurrency(item.pnl)}
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </CardContent>
                          </Card>
                        </div>
                      </div>

                      <div className="grid grid-cols-12 gap-x-4 mt-6 ">
                        <div className="col-span-12 ">
                          <Card className="p-0">
                            <CardContent className="p-0">
                              <MetricsTableOne
                                strategyWiseTradeMetrics={
                                  strategyWiseTradeMetrics
                                }
                              />
                            </CardContent>
                          </Card>
                        </div>
                      </div>

                      <div className="grid grid-cols-12 gap-x-4 mt-6 ">
                        <div className="col-span-12 ">
                          <Card className="p-0">
                            <CardContent className="p-0 ">
                              <MonthlyPnlTable
                                yearWiseStrategyWiseMonthlyPnl={
                                  yearWiseStrategyWiseMonthlyPnl
                                }
                              />
                            </CardContent>
                          </Card>
                        </div>
                      </div>

                      {/* <div className="grid grid-cols-12 gap-x-4 mt-6 ">
                    <div className="col-span-12 ">
                    <Card className="p-0">
                        <CardContent className="p-0">
                          <HeatmpaCalendar />
                        </CardContent>
                      </Card>
                    </div>
                  </div> */}
                    </div>
                  )}
                </TabsContent>
                <TabsContent
                  value="other-account"
                  className=" w-full rounded-md "
                ></TabsContent>
              </Tabs>
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
